let _scale = 0;
const _isSafari = /\bApple\b/.test(window.navigator.vendor);
const BROWSER_ZOOM_INVOLVED_KEY_CODES = [61, 107, 109, 173, 187, 189];

if (_isSafari) {
  document.body.classList.add('safari');
}

const onDocumentKeyDown = event => {
  const ctrlOrCmdPressed = event.ctrlKey || event.metaKey;

  if (ctrlOrCmdPressed && (BROWSER_ZOOM_INVOLVED_KEY_CODES.includes(event.which) || event.key === 'o')) {
    event.preventDefault();
  }
};

const onDocumentWheel = e => {
  if (e.ctrlKey || e.metaKey) {
    e.preventDefault();
    e.stopPropagation();
  }
};

const onGestureStart = e => {
  e.preventDefault();
  _scale = 1;
};

const onGestureChange = e => {
  e.preventDefault();
  if (!('scale' in e) || Number.isNaN(e.scale)) {
    return;
  }

  const scaleDelta = e.scale - _scale;
  _scale = e.scale;
  const { pageX, pageY } = e;

  const _evt = new WheelEvent('wheel', {
    bubbles: true,
    cancelable: true,
    clientX: pageX,
    clientY: pageY,
    x: pageX,
    y: pageY,
    pageX,
    pageY,
    deltaX: 0,
    deltaY: -scaleDelta,
    deltaZ: 0,
    deltaMode: 0,
  });
  const canvas = document.getElementById('canvas');
  if (canvas) {
    canvas.dispatchEvent(_evt);
  }
};

const addUiEvents = () => {
  document.addEventListener('keydown', onDocumentKeyDown);
  document.addEventListener('wheel', onDocumentWheel, {
    passive: false,
  });
  if (_isSafari) {
    document.addEventListener('gesturestart', onGestureStart);
    document.addEventListener('gesturechange', onGestureChange);
  }
};

const removeUiEvent = () => {
  document.removeEventListener('keydown', onDocumentKeyDown);
  document.removeEventListener('wheel', onDocumentWheel);
  document.removeEventListener('gesturestart', onGestureStart);
  document.removeEventListener('gesturechange', onGestureChange);
};

export { addUiEvents, removeUiEvent };
